// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U-Dz","top":"styles_top__16rls","left":"styles_left__2MFG9","description":"styles_description__VrZgT"};